import { render, staticRenderFns } from "./OfficeCollect.vue?vue&type=template&id=4b0f5d5f&scoped=true&"
import script from "./OfficeCollect.vue?vue&type=script&lang=js&"
export * from "./OfficeCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f5d5f",
  null
  
)

export default component.exports